import {GlobalGeist, GlobalThemeStyle, GlobalTooltipStyle} from '@dagster-io/ui-components';

export default function ThemedPage({children}: {children: React.ReactNode}) {
  return (
    <>
      <GlobalThemeStyle />
      <GlobalGeist />
      <GlobalTooltipStyle />
      <div style={{width: '100%'}}>{children}</div>
    </>
  );
}
